import { isEmpty, reject } from "lodash";
// types
import { TMainPageLayoutV2 } from "../type";
// utilities
import { 
    mainPageItemNameDescriptionLanguageVersion,
    metaDataLanguageVersion,
} from "@/utilities/LanguageVersionSelectorShortcut";
import RMDRLink from "@/components/RMDRLink";
import { useOutletContext } from "react-router-dom";
import TOutletContext from "@/cms/types/TOutletContext";


const MNPG024 = ( props: TMainPageLayoutV2 ) => {
    console.log("MNPG024.rendered", props);

    const { siteSettingPayload } = useOutletContext<TOutletContext>();

    if ( !props.template || isEmpty(props.template) ) return null;

    const languageVersion = mainPageItemNameDescriptionLanguageVersion(props.template.languageVersions);
    const buttonString = metaDataLanguageVersion("buttonString", props.template.languageVersions);
    const getStartedString = metaDataLanguageVersion("getStartedString", siteSettingPayload.languageVersions);

    const _buttonString = reject([buttonString,getStartedString], isEmpty);

    return (
        <RMDRLink
            title={languageVersion?.name}
            hasNavigationDestination={props.template.hasDestinationNavigation}
            navigationURL={languageVersion?.contentRouteNavigationURL}
            redirectType={props.template.redirectType}
            className="default-btn-two"
        >
            {_buttonString[0]} <i className="fas fa-chevron-right"></i>
        </RMDRLink>
    );
}

export default MNPG024;
